import type { Routes } from 'react-resource-router';
import { catalogRoutes } from './catalog';
import { labsRoutes } from './labs';
import { route as homeRoute } from './home';
import { assistantRoutes } from './assistant';
import { visualiserRoutes } from './visualiser';
import { queryBuilderRoutes } from './query-builder';
import { graphExplorerRoutes } from './graph-explorer';
import { cypherExplorerRoutes } from './cypher-explorer';
import { simpleGraphExplorerRoutes } from './simple-graph-explorer';

export const routes: Routes = [
	homeRoute,
	...catalogRoutes,
	...labsRoutes,
	...assistantRoutes,
	...visualiserRoutes,
	...queryBuilderRoutes,
	...graphExplorerRoutes,
	...cypherExplorerRoutes,
	...simpleGraphExplorerRoutes,
] as const;
